// extracted by mini-css-extract-plugin
export default {"Message":"Zw1zs61hu9iQjkj0SqBG","display":"T49Pao5IduJRSICHl3vg","WithDelay":"VZjeeDu2BdWK3iHnrlia"};